function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 78.5,
  cy: 78.5,
  r: 78.5,
  fill: "#F7F7F7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M76.9207 70.6787L76.9371 70.6873L31.8846 156.646L6.3069 143.297L50.8187 58.3699C50.9281 58.1454 51.0429 57.922 51.1633 57.7001C51.2057 57.6219 51.2486 57.5442 51.292 57.467L51.3594 57.3383L51.3638 57.3406C55.5762 49.9919 64.4244 47.0565 71.317 50.7933C78.0857 54.463 80.4915 63.2241 76.9207 70.6787Z",
  fill: "#AAAAAA"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 142.677,
  y: 20,
  width: 28.8511,
  height: 99.8912,
  transform: "rotate(71.2621 142.677 20)",
  fill: "#6D6D6D"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M151.835 47.3384L146.217 53.0525L51.6759 85.1432L57.2941 79.4291L151.835 47.3384Z",
  fill: "#4C4C4C"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 132.636,
  cy: 38.7153,
  r: 6.71279,
  transform: "rotate(71.2621 132.636 38.7153)",
  stroke: "#818181"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M48.0796 52.089L57.3571 79.4386L51.6757 85.1433L42.3982 57.7936L48.0796 52.089Z",
  fill: "#4C4C4C"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M6.34277 135.327L31.934 148.713L31.7609 156.762L6.16968 143.377L6.34277 135.327Z",
  fill: "#818181"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M74.3185 67.5768L74.3349 67.5854L31.9113 148.695L6.34591 135.324L48.2604 55.1871C48.363 54.975 48.4711 54.7642 48.5846 54.5549C48.6245 54.4811 48.6651 54.4079 48.7061 54.3351L48.7695 54.2137L48.7739 54.216C52.757 47.2904 61.421 44.6947 68.3136 48.4315C75.0823 52.1011 77.6656 60.5347 74.3185 67.5768Z",
  fill: "#C4C4C4"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 61.3853,
  cy: 61.4354,
  r: 6.71279,
  transform: "rotate(27.6113 61.3853 61.4354)",
  stroke: "#818181"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M24.2344 129.423C26.188 130.402 28.1374 131.379 30.1404 132.383C30.9055 130.857 31.696 129.369 32.3979 127.842C32.7257 127.126 32.4469 126.242 31.7793 125.88C30.2799 125.065 28.7357 124.335 27.1764 123.554C26.1847 125.532 25.2241 127.449 24.2344 129.423ZM21.6868 125.4C21.3142 126.144 20.9472 126.876 20.576 127.616C21.3371 127.998 22.0679 128.364 22.7933 128.728C23.1803 127.956 23.5357 127.247 23.9041 126.512C23.1403 126.129 22.4396 125.778 21.6868 125.4ZM24.6446 134.273C24.9737 133.616 25.2953 133.037 25.5481 132.429C25.6163 132.266 25.5487 131.9 25.4257 131.827C24.8234 131.468 24.1804 131.177 23.5237 130.847C23.1154 131.662 22.7559 132.379 22.3764 133.136C23.1251 133.511 23.8409 133.87 24.6446 134.273ZM25.7826 122.912C24.1295 121.81 23 122.191 22.3961 124.047C23.0156 124.358 23.64 124.697 24.2905 124.976C24.4238 125.033 24.7463 124.918 24.8206 124.79C25.1669 124.195 25.4535 123.569 25.7826 122.912ZM21.0164 132.42C21.3463 131.762 21.6754 131.157 21.9448 130.527C22.0026 130.391 21.8999 130.064 21.7749 129.991C21.1615 129.637 20.5165 129.34 19.8969 129.029C18.773 130.634 19.1436 131.763 21.0164 132.42ZM29.372 133.779C28.7552 133.47 28.1315 133.137 27.4858 132.851C27.3594 132.794 27.0548 132.87 26.9949 132.976C26.6362 133.609 26.3256 134.27 26.0061 134.907C27.6358 135.998 28.8341 135.589 29.372 133.779Z",
  fill: "#AAAAAA"
});

const SvgLedgerDevice = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 158,
    viewBox: "0 0 157 158",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLedgerDevice, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ledger-device.7775ecf9.svg";
export { ForwardRef as ReactComponent };